import React, { Component } from "react";
import Select from "react-select";

class MultiDropDown extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedOption: [],
      selectedOptionUpdated: [],
      menuIsOpen: false,
    };
  }
  componentDidMount() {}

  componentDidUpdate(prevProps) {
    if (this.props.selectGroupId != prevProps.selectGroupId) {
      this.setState({ selectedOption: [], selectedOptionUpdated: [] });
    }
  }

  handleChange = (selectedOption) => {
    if (selectedOption) {
      if (selectedOption.length > 10) {
        alert("Limit of 10 items reached");
      } else {
        this.setState({
          selectedOption: selectedOption,
          selectedOptionUpdated: selectedOption,
        });
        this.props.onParentCall(selectedOption);
      }
    } else {
      this.setState({ selectedOption: [], selectedOptionUpdated: [] });
      this.props.onParentCall([]);
    }
  };

  setMenuIsOpen = (menuOpen) => {
    if (menuOpen === true) {
      this.setState({
        menuIsOpen: menuOpen,
        selectedOptionUpdated: this.state.selectedOption,
      });
    } else {
      if (this.state.menuIsOpen === true) {
        this.setState({ menuIsOpen: menuOpen });
        if (this.state.selectedOption.length > 3) {
          const newLabel = `${this.state.selectedOption.length} assets selected`;
          const updatedSelectedOptions = this.state.selectedOption.map(
            (option) => ({ ...option, label: newLabel })
          )[0];
          this.setState({ selectedOptionUpdated: updatedSelectedOptions });
        }
      }
    }
  };

  render() {
    const customStyles = {
      control: (base, state) => ({
        ...base,
        background: "#f2f2f2",
        zIndex: 100,

        // match with the menu
        borderRadius: state.isFocused ? "3px 3px 0 0" : 3,
        // Overwrittes the different states of border
        borderColor: state.isFocused ? "#ccc" : "#ccc",
        // Removes weird border around container
        boxShadow: state.isFocused ? null : null,
        "&:hover": {
          // Overwrittes the different states of border
          borderColor: "none",
        },
      }),
      multiValue: (styles) => {
        return {
          ...styles,
          backgroundColor: "#ffffff",
          zIndex: 100,
        };
      },
      menu: (base) => ({
        ...base,
        // override border radius to match the box
        borderRadius: 0,
        zIndex: 100,

        // kill the gap
        marginTop: 0,
      }),
      menuList: (base) => ({
        ...base,
        // kill the white space on first and last option
        padding: 0,
        zIndex: 100,
      }),
    };
    const options = this.props.assetData.map((element) => {
      return {
        value: element.name,
        label: element.name,
        id: element.id,
      };
    });
    const { selectedOptionUpdated } = this.state;
    return (
      <div style={{ position: "relative" }}>
        <small
          className="text-muted"
          style={{ position: "absolute", top: "-20px", left: "0" }}
        >
          {(this.state.selectedOption.length > 0)
            && `Select a maximum of 10 vehicles`}
        </small>
        <Select
          value={selectedOptionUpdated}
          isMulti
          styles={customStyles}
          onChange={this.handleChange}
          options={options}
          closeMenuOnSelect={false}
          onMenuOpen={() => this.setMenuIsOpen(true)}
          onMenuClose={() => this.setMenuIsOpen(false)}
          placeholder="Select a maximum of 10 vehicles"
        />
      </div>
    );
  }
}

export default MultiDropDown;
